import classNames from "classnames";
import React, { useCallback, useEffect, useMemo, useReducer, useState } from "react";
import { useForm } from "react-hook-form";

type Props = {
    onComplete?: () => void
}

type GameQuestion = {
    text: string,
    hint: string,
    answer: string
}

const QUESTIONS = [
    {
        text: 'Często z tektury, dawniej ze skóry,<br />często błyszcząca, środek chroniąca.',
        hint: 'co chroni wewnętrzne kartki w książce?',
        answer: 'okładka'
    },
    {
        text: 'Zawsze jest w bajce, nie zawsze jest miły,<br />nakaże, zakaże, ale doda siły.',
        hint: 'mieści się zwykle na końcu bajki, ma na celu pouczenie lub przestrogę',
        answer: 'morał'
    },
    {
        text: 'Pierwszy, strojny i piękny, w akapicie stawiany.<br />Niegdyś przez mnichów starannie pisany.',
        hint: 'tym słowem określa się również pierwsze litery imienia i nazwiska',
        answer: 'inicjał'
    },
    {
        text: 'Papierowa wstęga, na dwa drążki nawijana.<br />Dawniej przez skrybów starannie chowana.',
        hint: 'dawna wersja książki w formie rulonu',
        answer: 'zwój'
    },
    {
        text: 'Co to za budynek, gdzie czas szybko ucieka,<br />ale życie tam możesz poznać innego człowieka?',
        hint: 'w jakim miejscu możecie znaleźć książki?',
        answer: 'biblioteka'
    },
    {
        text: 'Notatka krótka, ku bliskim skierowana.<br />Ważna dla pisarza, czasem osobiście napisana.',
        hint: 'krótka informacja, komu autor poświęca swoją książkę',
        answer: 'dedykacja',
    }
];

const Task305Game: React.FC<Props> = ({onComplete}) => {

    const [{ question }, nextQuestion] = useReducer((state) => {
        return {
            question: QUESTIONS[state.index + 1],
            index: state.index + 1
        }
    }, {
        question: QUESTIONS[0],
        index: 0
    });

    useEffect(() => {
        if (!question && onComplete) {
            onComplete();
        }
    }, [question, onComplete]);

    return <div className="task-305-game">
        {question && <Question data={question} onNext={nextQuestion} />}
        {!question && <p className="ending">Wszystkie zagadki rozwiązane!</p>}
    </div>
};

const Question: React.FC<{ data: GameQuestion, onNext(): void }> = ({ data, onNext }) => {

    const { register, watch, setValue } = useForm();

    const answer: string = watch('answer');

    const showNextButton = useMemo(() => {
        return data.answer === (answer || '').toLocaleLowerCase().trim();
    }, [answer, data]);

    const [showHint, setShowHint] = useState(false);

    const onKeyPress = useCallback((e: React.KeyboardEvent) => {
        if (showNextButton) {
            if (e.key === 'Enter') {
                onNext()
            }
        }
    }, [showNextButton, onNext]);

    useEffect(() => {
        setValue('answer', '');
        setShowHint(false);
    }, [data, setValue, setShowHint]);

    const inputClassname = classNames({
        answer: true,
        correct: data.answer === (answer || '').toLocaleLowerCase().trim()
    })

    return <>
        <div className="text" dangerouslySetInnerHTML={{ __html: data.text }}></div>
        <div className={inputClassname}>
            <input type="text" autoComplete='off' {...register('answer')} onKeyPress={onKeyPress} />
        </div>
        {!showNextButton && <div className="hint">
            {!showHint && <button onClick={() => setShowHint(true)}>Pokaż podpowiedź</button>}
            {showHint && <p>{data.hint}</p>}
        </div>}
        {showNextButton && <div className="next">
            <button onClick={onNext}>Następna zagadka</button>
        </div>}
    </>
}


export default Task305Game;
